const parseLocalStorageArray = (key) => {
  try {
    const parsedValue = JSON.parse(localStorage.getItem(key) || '[]');
    return Array.isArray(parsedValue) ? parsedValue : [];
  } catch {
    return [];
  }
};

export const getCachedSmsTemplates = () => parseLocalStorageArray('referral_sms_template');

export const getCachedReferralReplyTemplates = () => parseLocalStorageArray('referral_reply_templates');

export const getCachedReferralCallTemplates = () => parseLocalStorageArray('referral_call_templates');

export const getCachedDepartmentIds = () => parseLocalStorageArray('departments')
  .map((department) => department && department.id)
  .filter((departmentId) => departmentId !== undefined && departmentId !== null);

export const getVisibleSmsTemplatesForCurrentUser = () => {
  const userDepartmentIds = getCachedDepartmentIds();

  return getCachedSmsTemplates().filter((template) => template && (
    template.owner_type === 'Organization'
      || (template.owner_type === 'Department' && userDepartmentIds.includes(template.owner_id))
  ));
};
